import { IPropiedadesForma } from "../../interfaces/IPropiedadesForma";


export interface IMercanciaDatosComplementarios extends IPropiedadesForma {
    cantidad?: number
    claveUnidadId?: string
    claveUnidad?: any
    claveProductoId?: string
    claveProducto?: any
    descripcionMercancia?: string
    claveFraccionArancelariaId: string
    claveFraccionArancelaria?: any
    uuidComprobante?: string
    peso?: number
    camposParaValidar?: string[]
}

const camposParaValidar: string[] = [ 'cantidad','claveUnidadId','claveProductoId','descripcionMercancia','peso'];

export class MercanciaDatosComplementarios {
    constructor(props: IMercanciaDatosComplementarios) {
        Object.assign(this, props);
        this.esFormaValida = true;
        this.camposInvalidos = [];
      //  this.cantidad = 1;
        this.camposParaValidar = camposParaValidar;
    }

   
    LimpiarCampos(campoModificado: string) {
        if (campoModificado === "claveUnidadId" || campoModificado === "claveProductoId" || campoModificado === "claveFraccionArancelariaId" )
            this.camposParaValidar?.forEach(campo => {
                this[campo] = null;
            });
    }

   

}

export interface MercanciaDatosComplementarios extends IMercanciaDatosComplementarios {
}
